<template>
    <div class="detailsList">
        <p class="details_list_title_app">{{titleName}}</p>
        <div class="details_list_app">
            <ul>
                <li class="data_list_app" v-for="(item,index) in shufflingFunList" :key="item.id" @click="shufflingPicFun(item)">
                    <div v-if="item.image_url != ''" class="data_list_app_img" >
                        <img :src="item.image_url" alt="">
                    </div>
                    <div v-if="item.image_url != ''" class="data_list_content_apps">
                        <p class="list_title_app">{{item.title}}</p>
                        <p class="details_list_time_app"> <span>{{item.source}}</span> <span>{{item.pubDate}}</span> </p>
                    </div>
                    <div v-if="item.image_url == ''" class="data_list_content_app">
                        <p class="list_title_app">{{item.title}}</p>
                        <p class="details_list_time_app"> <span>{{item.source}}</span> <span>{{item.pubDate}}</span> </p>
                    </div>
                    
                </li>
            </ul>
        </div>
        <div class="loading_app" v-if="loading">
            <mt-spinner type="triple-bounce"></mt-spinner>
        </div>
        <div class="view_morm_btn" v-if="!loading && !areMore">
            <p class="view_morm_app" @click="listMorePaging()">查看更多 »</p>
        </div>
        <div class="view_morm_btn" v-if="areMore">
            <p class="view_morm_apps">没有更多内容了</p>
        </div>
    </div>
</template>
<script>
import { listApi, listDetails, generateSign } from '@/api/index'
// 濮阳新闻
const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "",
    userId: "",
    appInfoId: "10"
}
const shufflingAbstract = {
    type: 1,
    data: "",
    userId: "",
    appInfoId: "10"
}
export default {
    data(){
        return {
            shufflingFunListOne:null,
            // 濮阳新闻
            shuParameter: Object.assign({}, shufflingParameter),
            // shufflingAbstractOne: Object.assign({}, shufflingAbstract),
            shufflingFunList:null,
            shufflingFunListOne:null,
            abstractContent:[],
            loading:false,
            areMore:false,
            titleName:'',
            type : ''
        }
    },
    created(){
        this.shuParameter.columnId = this.$route.query.id
        this.titleName = this.$route.query.titleName
        this.type = this.$route.query.typeNum
        this.shufflingFuns()
    },
    methods:{
        checkDetails(uuid){
            this.$router.push({path:'/detailsList', query: {  id: uuid }})
        },
         // 濮阳新闻
        shufflingFuns(){
            const headers = { 
        'Sign': generateSign()
      };
            this.loading = true
            this.axios.post(listApi,this.shuParameter,{ headers }).then( res => {
                this.loading = false
                let lists = res.data.data[0].list
                if(this.shuParameter.pageNum>0){
                    lists.forEach((item,index) => {
                        this.shufflingFunList.push(item)
                    })
                }else{
                    this.shufflingFunList = lists
                }
                if(lists.length<10){
                    this.areMore = true
                }
                // this.newsLists()
            })
        },
        newsLists(){
            const headers = { 
        'Sign': generateSign()
      };
            this.abstractContent = []
            this.shufflingFunList.forEach((item,index) => {
                let listNews = {};
                let shufflingAbstractOne = {
                    type: 1,
                    id: item.id,
                    userId: "",
                    appInfoId: "10"
                }
                listNews['id'] = index

                this.axios.post(listDetails,shufflingAbstractOne,{ headers }).then(res => {
                    listNews['content'] = res.data.data[0].content.replace(/<(.[^>]*)>/g,'').replace(/&nbsp;/g,'').replace(/^\s+|\s+$/g,'').replace(/[\r\n]/g,'').replace(/[ ]/g, "")
                    this.abstractContent.push(listNews)
                })
            });
        },
        shufflingPicFun(types){
            this.$router.push({path:'/listDetailsApp', query: {  id: types.id,jsonUrl:types.jsonUrl , typeNum : this.type,url:types.url}})
        },
        listMorePaging(){
            this.shuParameter.columnId = this.$route.query.id
            this.shuParameter.pageNum = this.shuParameter.pageNum +1
            this.shufflingFuns()
        }
    }
}
</script>
<style lang="">
    .loading_app{
        text-align: center;
        margin:1rem 0;
    }
    .data_list_app{
        min-height:1rem;
        padding:0.6rem 0;
        border-bottom:0.02rem solid #DCDCDC;
    }
    .data_list_content_app{
        min-height:4rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }
    .data_list_content_apps{
        min-height:5rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }
    .data_list_app .data_list_app_img{
        width:7rem;
        height:5rem;
        float:left;
        overflow: hidden;
        border-radius: 0.2rem;
        margin-right:0.8rem;
    }
    .data_list_app_img img{
        width:100%;
        height:100%;
        display:block;
    }
    .detailsList{
        margin:1rem 0.8rem;
        min-height: calc(100vh - 11.4rem);
    }
    .details_list_title_app{
        font-size: 1.2rem;
        font-weight: bolder;
        color:#C90304;
    }
    .list_title_app{
        font-size:1.2rem;
        min-height:1rem;
        line-height:1.6rem;
        font-family:Source Han Sans CN;
        color:#333333;
        width:100%;
    }
    .details_list_app .details_list_time_app{
        font-size:0.8rem;
        color:#A1A1A1;
    }
    .details_list_app .details_list_time_app span{
        padding-right:0.6rem;
    }
    .view_morm_btn{
        margin:0.6rem 0;
        height:3rem;
        background: #efefef;
        border:0.05rem solid #DCDCDC;
        text-align: center;
        line-height:3rem;
    }
    .view_morm_btn .view_morm_app{
        font-size: 1.2rem;
        color:#C90304;
    }
    .view_morm_btn .view_morm_apps{
        font-size: 1.2rem;
        color:#928f90;
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/homePageApp/appContentList/detailsList/publicList.vue